import React, {forwardRef, useContext, useRef} from 'react';
import {Divider, Radio} from 'antd';
import styles from './index.module.less';
import _ from 'lodash';
import {useAuthStore} from '@/context/auth';
import UserSelect from '@/page/customer/WelcomPage/UserSelect';
import {TeamOutlined} from '@/icons';
import MsgContext from '@/page/customer/WelcomPage/msgContext';

const SendArea = forwardRef((props, ref) => {
    const {
        sender, setSelectedUsers, count, setCount, selectedUsers, names, setNames,
    } = useContext(MsgContext);
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const selectRef = useRef();


    function onReportLineUserSelect(parentId, values, sendGroupType) {
        const users = _.get(values, 'users', []);
        if (_.isEmpty(users)) {
            // message.warn('未选择任何用户');
            setCount(0);
            setNames('');
            setSelectedUsers(null);
            return false;
        }
        const subUserIds = users.map(({id}) => id);
        let str = '';
        users.forEach(item => {
            const {name} = item;
            str = str + ',' + name;
        });
        str = str.substr(1);
        setSelectedUsers(values);
        setCount(subUserIds.length);
        setNames(str);
        selectRef.current.closeModal();
    }

    return (<div className={styles.container}>
        <div className={styles.send}>
            <a
                href="#"
                onClick={() => selectRef.current.showModal(sender)}
            >
                （选择范围）
            </a>
            <Divider type="vertical" />
            <div>
                &nbsp;
                <TeamOutlined />
                &nbsp; 已选择
                <a href="#" title={names}>
                    {names.length > 30 ? names.substr(0, 27) + '...' : names}
                </a>
                {(count > 0 && '等') + count + '人'}
            </div>
            <UserSelect
                ref={selectRef}
                showTagTab={false}
                showDepartTab={false}
                onSelect={onReportLineUserSelect}
            />
        </div>
    </div>);
});

SendArea.displayName = 'SendArea';

SendArea.propTypes = {};

export default SendArea;
